import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CollectionItem, VerifyResponse} from '../collection-item.model';
import {endpoints} from '../../../core/configs/endpoints';

/**
 * Service to interact with the CollectionItem API.
 * Provides methods to retrieve, create, and delete collection items.
 */
@Injectable({providedIn: 'root'})
export class CollectionItemApiService {
  private readonly _httpClient = inject(HttpClient)


  /**
   * Retrieves the collection of a specific user.
   * @param collectionItemId - The ID of the collection-item whose  is being retrieved.
   * @returns An Observable emitting the collection's collection-item.
   */
  public getCollectionItem(collectionItemId: string): Observable<CollectionItem> {
    return this._httpClient.get<CollectionItem>(`${endpoints.collection_item.collection_item}/${collectionItemId}`);
  }

  public deleteCollectionItem(collectionItemId: string): Observable<CollectionItem> {
    return this._httpClient.post<CollectionItem>(`${endpoints.collection_item.delete}`, {params: {collectionItemId: collectionItemId}});
  }

  public getCollectionItemImage(imageId: string) {
    return this._httpClient.get(`${endpoints.collection_item.image}/${imageId}`, {
      responseType: 'blob' // Oppure 'arraybuffer' se devi manipolare ulteriormente i dati
    });
  }

  verifyWarranty(): Observable<VerifyResponse> {
    return this._httpClient.get<VerifyResponse>(endpoints.user.verify);
  }

  extendWarranty(collectionItemId: string, policyId: number): Observable<any> {
    return this._httpClient.post(endpoints.collection_item.extend, {params: {collectionItemId, policyId}});
  }

}
